import React, {Suspense, useState} from 'react';
import useIntersectionObserver from '@stencil/use-intersection-observer';
import {detailsNavigationIds} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';

import SimilarHotelsLoader from '../../../../../stories/components/hotels/Loadingpage/SimilarHotelsLoader/SimilarHotelsLoader';

const SimilarHotelsComponent = React.lazy(() => import('./SimilarHotels'));

const SimilarHotelsChunk = () => {
  return (
    <Suspense fallback={<SimilarHotelsLoader />}>
      <SimilarHotelsComponent />
    </Suspense>
  );
};

const intersectionObserverOptions = {
  root: null,
  threshHold: 0.01,
};

const SimilarHotels = () => {
  const [visible, setVisible] = useState(false);

  const [watcherRef] = useIntersectionObserver(intersectionObserverOptions, () => {
    setVisible(true);
  });
  return (
    <div ref={watcherRef} id={detailsNavigationIds.similarHotels}>
      {(visible && <SimilarHotelsChunk />) || null}
    </div>
  );
};

export default SimilarHotels;
